<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tablePatchBaselineDate" :loading="patchBaselineLoadings" height="500" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="delete">
                <!-- <Button type="warning" size="small" @click="addOrUpdateHandle(row.id)">{{ $t('alarms.common.edit') }}</Button> -->
                <span @click="detail(index)">
                    <Button type="info" size="small" @click="patchDetail(row)">{{ $t('alarms.common.details') }}</Button>
                </span>
            </template>
        </Table>
        <!-- 补丁基准详情模式框 -->
        <Modal v-model="patchDetailModal" :title="$t('patch_management.patch_policy.patchBaselineDetail')" :mask-closable="false" width="800px">
            <Row style="width: 92%;margin: auto;">
                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.baselineId') }}</Col>
                            <Col span="24">{{baselineId}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.baselineName') }}</Col>
                            <Col span="24">{{baselineName}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.description') }}</Col>
                            <Col span="24">{{description}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.os') }}</Col>
                            <Col span="24">{{operatingSystem}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.defaultBaseline') }}</Col>
                            <Col span="24">{{defaultBaseline}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.patchGroup') }}</Col>
                            <Col span="24" v-for="(item, index) in patchGroups" :key="index">{{item}}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="14">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.createdDate') }} (UTC)</Col>
                            <Col span="24">{{createdDate}}</Col>
                        </Row>
                    </Col>
                    <Col span="10">
                        <Row style="margin-bottom: 20px;">
                            <Col span="24">{{ $t('patch_management.patch_policy.modifiedDate') }} (UTC)</Col>
                            <Col span="24">{{modifiedDate}}</Col>
                        </Row>
                    </Col>
                </Row>
            </Row>
            <div slot="footer">
                <Button size="large" @click="cancel">{{ $t('alarms.common.cancel') }}</Button>
            </div>
        </Modal>
        <add-or-update-patch-baseline v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-patch-baseline>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdatePatchBaseline from '../patch_baseline_configuration/AddOrUpdatePatchBaseline'
    var tablePatchBaselineVue = {};
    export default {
        name: 'TablePatchBaseline',
        components: {
            AddOrUpdatePatchBaseline
        },
        data () {
            return {
                patchBaselineLoadings: false,
                patchDetailModal:false,
                addOrUpdateVisible:false,
                accountIdSearchKey:'',
                regionSearchKey:'',
                operatingSystemSearchKey:'',
                baselineId:'',
                baselineName:'',
                description:'',
                operatingSystem:'',
                patchGroups:[],
                createdDate:'',
                modifiedDate:'',
                defaultBaseline:'',
                columns: [
                    {
                        title: this.$t('PatchEasy.PatchPolicy.stdID'),
                        key: 'baselineId'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.stdName'),
                        key: 'baselineName'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.description'),
                        key: 'baselineDescription'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.OS'),
                        key: 'operatingSystem'
                    },
                    {
                        title: this.$t('PatchEasy.PatchPolicy.defaultStd'),
                        key: 'defaultBaseline'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'delete'
                    }
                ],
                tablePatchBaselineDate:[]
            }
        },
        beforeCreate: function() {
            tablePatchBaselineVue = this
        },
        methods: {
            showAll: function(accountIdSearchKey,regionSearchKey,operatingSystemSearchKey){
                tablePatchBaselineVue.accountIdSearchKey = accountIdSearchKey;
                tablePatchBaselineVue.regionSearchKey = regionSearchKey;
                tablePatchBaselineVue.operatingSystemSearchKey = operatingSystemSearchKey;
                tablePatchBaselineVue.getPatchBaselineData();
            },
            // 分页显示数据
            /****************************************************/
            getPatchBaselineData:function() {
                this.patchBaselineLoadings = true;
                //分页
                this.$api.policy.listPatchBaseline({
                    "awssmPatcheRequestDTO" : {
                        // "maxResults":50,
                        "operatingSystem" : tablePatchBaselineVue.operatingSystemSearchKey
                    },
                    "accountId" : tablePatchBaselineVue.accountIdSearchKey,
                    "regionString" : tablePatchBaselineVue.regionSearchKey
                })
                .then(res => {
                    this.tablePatchBaselineDate = res.data.baselineIdentities;
                    this.patchBaselineLoadings = false;
                });
            },
            // 详情
            /****************************************************/
            detail: function(index){
                this.lineIndex=index;
                this.defaultBaseline=this.tablePatchBaselineDate[index].defaultBaseline;
            },
            // 点击详情
            patchDetail:function(row){
                this.patchDetailModal=true;
                this.$api.policy.getPatchBaselineDetail({
                    "patchBaselineId":row.baselineId,
                    "accountId" : tablePatchBaselineVue.accountIdSearchKey,
                    "regionString" : tablePatchBaselineVue.regionSearchKey
                })
                .then(res => {
                    this.baselineId=res.data.baselineId;
                    this.baselineName=res.data.baselineName;
                    this.description=res.data.description;
                    this.operatingSystem=res.data.operatingSystem;
                    this.patchGroups=res.data.patchGroups;
                    this.createdDate=res.data.createdDate;
                    this.modifiedDate=res.data.modifiedDate;
                });
            },
            // 取消
            cancel:function(){
                this.patchDetailModal=false;
            },
            // 编辑报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(id){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/patch_baseline_configuration/TablePatchBaseline.vue